module.exports = __webpack_public_path__ + "img/t3-9.fa0f5ded.svg";